import React from "react";

// =============================================================================
// Biodiversity Slide: Overview of the biodiversity planting area
// =============================================================================

export default function BiodiversitySlide({
  tree,
  sensorInfo,
  slideIndex,
  totalSlides,
  progressPct,
  onGoTo,
}) {
  return (
    <div className="dv3-slide dv3-slide--biodiversity">
      <div className="dv3-slide__header">
        <div className={`dv2-sensor-badge dv2-sensor-badge--${sensorInfo?.type || "soil"}`}>
          <span className="dv2-s-dot" />
          {sensorInfo?.label || "FDR-Bodensensor aktiv"}
        </div>
        <div className="dv2-nav-dots">
          {Array.from({ length: totalSlides }).map((_, i) => (
            <button
              key={i}
              type="button"
              className={`dv2-nd ${i === slideIndex ? "dv2-nd--on" : ""}`}
              onClick={() => onGoTo(i)}
              aria-label={`Folie ${i + 1}`}
            />
          ))}
        </div>
      </div>

      <div className="dv3-slide__title-row">
        <div className="dv3-slide__tree-name">{tree?.name || "Biodiversitätsfläche"}</div>
        <div className="dv3-slide__tree-species">
          Staudenpflanzungen für mehr Biodiversität · Neuaubing-Aubing-Westkreuz
        </div>
      </div>

      <div className="dv3-info-slide">
        <div
          className="dv3-info-slide__intro"
          style={{ fontSize: "15px", lineHeight: "1.65", marginBottom: "6px" }}
        >
          Mehr Biodiversität mitten in der Stadt: Staudenpflanzflächen sind mehr als nur schön
          anzusehen. Sie schaffen wertvolle Lebensräume für Insekten, verbessern das Stadtklima und
          machen öffentliche Räume lebendiger. Durch die Auswahl vielfältiger, klimaangepasster
          Pflanzen entstehen blühende Flächen, die über viele Monate Nahrung und Schutz bieten.
        </div>

        <div className="dv3-info-section">
          <div className="dv3-info-section__label">Wissenswertes zur Fläche</div>
          <div className="dv3-info-facts">
            <div className="dv3-info-fact">
              <div className="dv3-info-fact__icon">
                <img src="/img/weather/trees-leaves.png" alt="" aria-hidden="true" />
              </div>
              <div className="dv3-info-fact__body">
                <div className="dv3-info-fact__title">Verbreitung</div>
                <div className="dv3-info-fact__desc">
                  Die Mischung besteht vollständig aus Arten, die im mitteldeutschen Raum heimisch
                  sind.
                </div>
              </div>
            </div>

            <div className="dv3-info-fact">
              <div className="dv3-info-fact__icon">
                <img src="/img/weather/cloud.png" alt="" aria-hidden="true" />
              </div>
              <div className="dv3-info-fact__body">
                <div className="dv3-info-fact__title">Boden</div>
                <div className="dv3-info-fact__desc">
                  Leicht sowie durchlässige Böden, auch auf Kalkschotter.
                </div>
              </div>
            </div>

            <div className="dv3-info-fact">
              <div className="dv3-info-fact__icon">
                <img src="/img/weather/watering.png" alt="" aria-hidden="true" />
              </div>
              <div className="dv3-info-fact__body">
                <div className="dv3-info-fact__title">Sensorik</div>
                <div className="dv3-info-fact__desc">
                  Ein integrierter Bodenfeuchtesensor misst kontinuierlich Feuchtigkeit und
                  Temperatur im Boden.
                </div>
              </div>
            </div>

            <div className="dv3-info-fact">
              <div className="dv3-info-fact__icon">
                <img src="/img/weather/watering.png" alt="" aria-hidden="true" />
              </div>
              <div className="dv3-info-fact__body">
                <div className="dv3-info-fact__title">Bewässerung</div>
                <div className="dv3-info-fact__desc">
                  Die Daten ermöglichen eine präzise, bedarfsgerechte Bewässerung und zeigen, wann
                  die Pflanzen tatsächlich Wasser brauchen.
                </div>
              </div>
            </div>

            <div className="dv3-info-fact">
              <div className="dv3-info-fact__icon">
                <img src="/img/weather/trees-leaves.png" alt="" aria-hidden="true" />
              </div>
              <div className="dv3-info-fact__body">
                <div className="dv3-info-fact__title">Mehr Leben auf der Fläche</div>
                <div className="dv3-info-fact__desc">
                  Staudenpflanzungen können die Artenvielfalt von Insekten im Vergleich zu
                  klassischen Rasenflächen um ein Vielfaches erhöhen.
                </div>
              </div>
            </div>

            <div className="dv3-info-fact">
              <div className="dv3-info-fact__icon">
                <img src="/img/weather/cloud.png" alt="" aria-hidden="true" />
              </div>
              <div className="dv3-info-fact__body">
                <div className="dv3-info-fact__title">Weniger Pflege, besseres Mikroklima</div>
                <div className="dv3-info-fact__desc">
                  Klimaangepasste Stauden brauchen weniger Wasser und verbessern Mikroklima und
                  Aufenthaltsqualität.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="dv2-prog-bar" style={{ width: `${progressPct}%` }} />
    </div>
  );
}
